module.exports = __webpack_public_path__ + "static/media/red_tab.3576f5f8.svg";